"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/** useClickOutside - custom hooks that handles the annoying task
 * of handling logic when a user clicks outside of a given element
 *
 * node: the node to track clicks outside out
 * callback: function to run when the user clicks outside
 */
function useClickOutside(node, callback) {
    react_1.useEffect(function () {
        function handleClick(e) {
            if (node.current && node.current.contains(e.target)) {
                return;
            }
            else {
                callback();
            }
        }
        document.addEventListener("mousedown", handleClick, false);
        return function () {
            document.removeEventListener("mousedown", handleClick, false);
        };
    }, [callback, node]);
}
exports.useClickOutside = useClickOutside;
